import React from 'react';

import AddIcon from '@mui/icons-material/Add';
import WaterDropIcon from '@mui/icons-material/WaterDrop';
import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import ChunkyButton from 'client/app/apps/disco-prototype/components/ChunkyButton';
import { discoPrototypeRoutes } from 'client/app/apps/disco-prototype/DiscoPrototypeRouter';
import { LiquidSet } from 'client/app/apps/disco-prototype/state/liquidSet';

type LiquidsetsProps = {
  items: LiquidSet[];
};

const Liquidsets: React.FC<LiquidsetsProps> = ({ items }) => {
  return (
    <Box>
      <Box display="flex" alignItems="center" gap={1} mb={2}>
        <WaterDropIcon color="primary" />
        <Typography variant="h6">Liquid sets ({items.length})</Typography>
      </Box>

      <Stack spacing={4} m={4}>
        {items.map(item => (
          <Chip
            key={item.id}
            icon={<WaterDropIcon />}
            label={`${item.name} (${item.table.rows.length})`}
            variant="outlined"
            sx={theme => ({
              backgroundColor: theme.palette.grey[200],
              borderRadius: theme.spacing(4),
              justifyContent: 'flex-start',
            })}
          />
        ))}
      </Stack>

      <ChunkyButton
        backgroundColor="white"
        startIcon={<AddIcon />}
        to={discoPrototypeRoutes.defineLiguidSet.getPath()}
      >
        Manage Liquids
      </ChunkyButton>
    </Box>
  );
};

export default Liquidsets;
